<template>
    <v-switch
        @change="switchBlockVisibility"
        :loading="loading" :readonly="loading"
        v-model="WebAppVisible"
    ></v-switch>
</template>

<script>
export default {
    name: "BlockVisibilitySwitch",
    props: {
        block: Object
    },
    data() {
        return {
            WebAppVisible: null,
            loading: false,
        }
    },
    methods: {
        switchBlockVisibility: function () {
            this.loading = true;

            apiAxios.put('blocks/'+this.block.BlockID+'/web_app_visibility', {
                WebAppVisible: this.WebAppVisible
            })
                .then((response) => {
                    if(response.status === 200) {
                        this.$store.commit(
                            "showSnackbarSuccess",
                            'Zmieniono widoczność bloku.'
                        );
                    } else {
                        this.active = !this.active;
                        this.$store.commit(
                            "showSnackbarError",
                            'Nie udało się zmienić widoczności bloku.'
                        );
                    }
                })
                .catch(() => {
                    this.visible = !this.visible;
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
    created() {
        this.WebAppVisible = this.block.WebAppVisible;
    }
}
</script>

<style scoped>

</style>
